const Layout = () => import(/* webpackChunkName: "base" */'@/components/common/Layout');
const InspectTemplate = () => import(/* webpackChunkName: "inspect" */'@/components/pages/inspect/template/InspectTemplate');
const OperateInspectTemplate = () => import(/* webpackChunkName: "inspect" */'@/components/pages/inspect/template/OperateInspectTemplate');
const InspectDuty = () => import(/* webpackChunkName: "inspect" */'@/components/pages/inspect/duty/InspectDuty');
const OperateInspectDuty = () => import(/* webpackChunkName: "inspect" */'@/components/pages/inspect/duty/OperateInspectDuty');
const CreateAssetRelevant = () => import(/* webpackChunkName: "asset" */'@/components/pages/asset/CreateAssetRelevant');
const InspectReceipt = () => import(/* webpackChunkName: "asset" */'@/components/pages/inspect/receipt/InspectReceipt');
const InspectReceiptDetail = () => import(/* webpackChunkName: "asset" */'@/components/pages/inspect/receipt/InspectReceiptDetail');
// v1.4 巡检详情页面
const NewDetail = () => import(/* webpackChunkName: "asset" */'@/components/pages/inspect/receipt/NewDetail');
const InspectReport = () => import(/* webpackChunkName: "asset" */'@/components/pages/inspect/receipt/InspectReport');
const InspectAssetResult = () => import(/* webpackChunkName: "asset" */'@/components/pages/inspect/receipt/InspectAssetResult');

export default [
  {
    path: '/inspect',
    name: 'inspect',
    component: Layout,
    meta: {
      title: '巡检管理',
      icon: 'inspect-manage',
      roles: [
        'INS_JOB_QUERY',
        'INS_TEMPLATE_QUERY',
        'INS_JOB_RECORD_QUERY'
      ]
    },
    children: [
      {
        path: 'inspect-template',
        name: 'inspectTemplate',
        meta: {
          title: '巡检模板',
          roles: ['INS_TEMPLATE_QUERY'],
          componentName: 'InspectTemplate',
          breadcrumb: [
            {
              name: '巡检模板',
              path: '/inspect/inspect-template'
            }
          ]
        },
        component: InspectTemplate
      },
      {
        path: 'create-inspect-template',
        name: 'createInspectTemplate',
        meta: {
          title: '新建巡检模板',
          hidden: true,
          activeMenu: '/inspect/inspect-template',
          roles: ['INS_TEMPLATE_ADD'],
          componentName: 'OperateInspectTemplate',
          breadcrumb: [
            {
              name: '巡检模板',
              path: '/inspect/inspect-template'
            },
            {
              name: '新建巡检模板',
              path: '/inspect/create-inspect-template'
            }
          ]
        },
        component: OperateInspectTemplate
      },
      {
        path: 'edit-inspect-template/:id',
        props: true,
        name: 'editInspectTemplate',
        meta: {
          title: '编辑巡检模板',
          hidden: true,
          activeMenu: '/inspect/inspect-template',
          roles: ['INS_TEMPLATE_UPDATE'],
          componentName: 'OperateInspectTemplate',
          breadcrumb: [
            {
              name: '巡检模板',
              path: '/inspect/inspect-template'
            },
            {
              name: '编辑巡检模板',
              path: '/inspect/edit-inspect-template/:id'
            }
          ]
        },
        component: OperateInspectTemplate
      },
      {
        path: 'inspect-duty',
        name: 'inspectDuty',
        meta: {
          title: '巡检周期',
          roles: ['INS_JOB_QUERY'],
          componentName: 'InspectDuty',
          breadcrumb: [
            {
              name: '巡检周期',
              path: '/inspect/inspect-duty'
            }
          ]
        },
        component: InspectDuty
      },
      {
        path: 'create-inspect-duty',
        name: 'createInspectDuty',
        meta: {
          title: '新建巡检周期任务',
          hidden: true,
          activeMenu: '/inspect/inspect-duty',
          roles: ['INS_JOB_ADD'],
          componentName: 'OperateInspectDuty',
          breadcrumb: [
            {
              name: '巡检周期',
              path: '/inspect/inspect-duty'
            },
            {
              name: '新建巡检周期任务',
              path: '/inspect/create-inspect-duty'
            }
          ]
        },
        component: OperateInspectDuty
      },
      {
        path: 'edit-inspect-duty/:id',
        props: true,
        name: 'editInspectDuty',
        meta: {
          title: '编辑巡检周期任务',
          hidden: true,
          activeMenu: '/inspect/inspect-duty',
          roles: ['INS_JOB_UPDATE'],
          componentName: 'OperateInspectDuty',
          breadcrumb: [
            {
              name: '巡检周期',
              path: '/inspect/inspect-duty'
            },
            {
              name: '编辑巡检周期任务',
              path: '/inspect/edit-inspect-duty/:id'
            }
          ]
        },
        component: OperateInspectDuty
      },
      {
        path: 'inspect-duty/create-asset-relevant',
        name: 'inspectDutyRelevantAsset',
        meta: {
          title: '关联资产',
          hidden: true,
          activeMenu: '/inspect/inspect-duty',
          roles: [],
          componentName: 'CreateAssetRelevant',
          breadcrumb: [
            {
              name: '巡检周期',
              path: '/inspect/inspect-duty'
            },
            {
              name: '关联资产',
              path: '/inspect/inspect-duty/create-asset-relevant'
            }
          ]
        },
        component: CreateAssetRelevant
      },
      {
        path: 'inspect-receipt',
        name: 'InspectReceipt',
        meta: {
          title: '巡检任务',
          activeMenu: '/inspect/inspect-receipt',
          roles: ['INS_JOB_RECORD_QUERY'],
          componentName: 'InspectReceipt',
          breadcrumb: [
            {
              name: '巡检任务',
              path: '/inspect/inspect-receipt'
            }
          ]
        },
        component: InspectReceipt
      },
      {
        path: 'inspect-receipt/:id',
        props: true,
        name: 'inspectReceiptDetail',
        meta: {
          title: '巡检任务单详情',
          hidden: true,
          activeMenu: '/inspect/inspect-receipt',
          roles: ['INS_JOB_RECORD_DETAIL_QUERY', 'INS_JOB_RECORD_ASEET_INSPECT'],
          componentName: 'InspectReceiptDetail',
          breadcrumb: [
            {
              name: '巡检任务',
              path: '/inspect/inspect-receipt'
            },
            {
              name: '巡检任务单详情',
              path: '/inspect/inspect-receipt/:id'
            }
          ]
        },
        component: NewDetail
      },
      {
        path: 'inspect-receipt/:id/assets/:assetId',
        props: true,
        name: 'inspectAssetResult',
        meta: {
          title: '巡检资产结果',
          hidden: true,
          activeMenu: '/inspect/inspect-receipt',
          roles: ['INS_JOB_RECORD_RESULT_QUERY'],
          componentName: 'InspectAssetResult',
          breadcrumb: [
            {
              name: '巡检任务',
              path: '/inspect/inspect-receipt'
            },
            {
              name: '巡检任务单详情',
              path: '/inspect/inspect-receipt/:id/assets/:assetId'
            }
          ]
        },
        component: InspectAssetResult
      }
    ]
  },
  {
    path: '/inspect/inspect-report/:id',
    props: true,
    name: 'inspectReport',
    component: InspectReport,
    meta: {
      componentName: 'InspectReport',
      roles: ['INS_JOB_RECORD_REPORT_QUERY']
    }
  }
];


// WEBPACK FOOTER //
// ./src/router/inspectManage.js